import BaseMapVictims from "#root/components/BaseMapVictims";

const ViewerMap: React.FC = () => {
    return (
        <BaseMapVictims 
            enablePdfButton={true} 
            mode="viewer"
        />
    );
};

export default ViewerMap;